import * as React from 'react';
import { Checkbox as FluentCheckbox, type CheckboxProps as FluentCheckboxProps } from '@fluentui/react-components';

export type CheckboxProps = Omit<FluentCheckboxProps, 'size' | 'onChange'> & {
  size?: 'default' | 'sm' | 'lg';
  onCheckedChange?: (checked: boolean) => void;
};

function mapSize(size?: CheckboxProps['size']): FluentCheckboxProps['size'] {
  switch (size) {
    case 'sm':
      return 'medium';
    case 'lg':
      return 'large';
    case 'default':
    default:
      return 'medium';
  }
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ size = 'default', className, onCheckedChange, ...rest }, ref) => {
    const handleChange: FluentCheckboxProps['onChange'] = (_ev, data) => {
      onCheckedChange?.(!!data.checked);
    };

    return (
      <FluentCheckbox
        size={mapSize(size)}
        className={className}
        onChange={handleChange}
        ref={ref}
        {...rest}
      />
    );
  }
);

Checkbox.displayName = 'Checkbox';


